import React from 'react';

const Blog = () => {
    return (
        <div className='my-20'>
            <h1 className='text-4xl text-center font-bold'>Coming Soon...</h1>
        </div>
    );
};

export default Blog;